import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  changeLangAction,
  changeCustomerAction,
  logout,
  redirectToProfile
} from '../../actions/Actions';
import SelectBox from '../selectbox/SelectBox';
import Message from '../../locale/Message';
import './header.scss';
import UserApi from '../../api/UserApi';
import { addToStorage } from '../../utils/webStorage';
import { LOCAL_STORAGE_LANG_KEY } from '../../config/constants';

class Header extends Component {
  changeLang = (value) => {
    const { changeLang } = this.props;
    addToStorage(LOCAL_STORAGE_LANG_KEY, value);
    changeLang(value);
  };

  changeCustomer = (value) => {
    const { changeCustomer, userInfo, history } = this.props;
    changeCustomer(userInfo.customers.filter(it => it.idDocNum === value)[0]);
    UserApi.checkUser();
    // stay on the same page
    // history.push('/');
  };

  renderLangSelectBox = ({ lang, changeLang }) => (
    <SelectBox
      sectionClassName="d-inline-block position-relative mr-4"
      value={lang}
      header={Message.selectLang[lang]}
      ulClassName="t-light mb-0 selectbox lang-switcher bg-white text-midnight-gray"
      spanClassName="selectbox-title text-left cursor-pointer"
      data={[
        { name: 'РУССКИЙ', value: 'ru' },
        { name: 'ENGLISH', value: 'en' },
        { name: 'ҚАЗАҚ', value: 'kk' },
      ]}
      onSelect={this.changeLang}
    />
  );

  renderChangeCustomerSelectBox = ({ customer, userInfo, lang }) => {
    if (!(userInfo && customer && userInfo.customers)) {
      return null;
    }
    const customers = userInfo.customers;

    return customers[0] && (
      <SelectBox
        value={customer.idDocNum}
        sectionClassName="d-inline-block position-relative pr-2 profile-name"
        header={Message.selectCompany[lang]}
        ulClassName="t-light mb-0 selectbox bg-white text-midnight-gray"
        spanClassName="selectbox-title text-left cursor-pointer"
        data={
          customers.map(it => ({
            name: it.alias || Message.bin[lang] + it.idDocNum,
            value: it.idDocNum,
          }))
        }
        onSelect={this.changeCustomer}
      />
    );
  };

  renderUserMenu = ({ userInfo, lang }) => userInfo
    && (
      <SelectBox
        sectionClassName="d-inline-block position-relative cursor-pointer"
        ulClassName="t-light mb-0 selectbox bg-white text-midnight-gray profile-option-selectbox"
        header={(
          <div className="d-flex">
            <div className="icon bg-purple text-white">
              {userInfo.firstName && userInfo.firstName.charAt(0)}
            </div>
            {userInfo.firstName}
            {' '}
            {userInfo.lastName}
          </div>
        )}
        data={[
          {
            name: Message.myProfile[lang], value: 1,
          }, {
            name: Message.exit[lang], value: 2,
          }]}
        onSelect={(value) => {
          switch (value) {
            case 1:
              redirectToProfile();
              break;
            case 2:
              logout();
              break;
          }
        }}
      >
        <div
          className="profile-icon bg-white rounded-circle text-purple text-center d-inline-block"
        >
          {userInfo.firstName && userInfo.firstName.charAt(0)}
        </div>
        <div className="profile-option bg-white rounded-circle text-purple text-center">
          <i className="fa fa-angle-down" />
        </div>
      </SelectBox>
    );

  renderServiceMenu({ customer, lang }) {
    if (!customer || !customer.services || Object.keys(customer.services).length === 0) {
      return null;
    }
    const services = customer.services;
    return (
      <div className="d-inline-block">
        <span className="divider divider-lg d-none d-lg-inline" />
        <SelectBox
          sectionClassName="position-relative ml-4 d-none d-lg-inline-block"
          header={Message.chooseService[lang]}
          spanClassName="selectbox-title text-left cursor-pointer menu align-middle"
          ulClassName="t-light mb-0 selectbox bg-white text-midnight-gray"
          data={
            Object.keys(services).map(alias => ({
              name: services[alias].name[lang],
              value: services[alias].url,
            }))
          }
          value={services.msg && services.msg.url}
          defaultName={Message.chooseService[lang]}
          onSelect={value => document.location = value}
        />

        <nav className="d-inline-block align-middle d-lg-none">
          <input type="checkbox" id="nav" className="d-none" />
          <label htmlFor="nav" className="nav-open">
            <i className="bg-white" />
            <i className="bg-white" />
            <i className="bg-white" />
          </label>
          <div className="nav-container clearfix bg-purple">
            <ul className="mb-0 pl-0 menu">
              {
                Object.keys(services)
                  .map(
                    (alias, index) => (
                      <li className="d-inline-block" key={index}>
                        <a href={services[alias].url}>{services[alias].name[lang]}</a>
                      </li>
                    ),
                  )
              }
            </ul>
          </div>
        </nav>
      </div>
    );
  };

  render() {
    return (
      <header className="global-header bg-purple">
        <div className="d-flex justify-content-between">
          <div>
            <Link to="/" style={{lineHeight: '42px'}}>
              <img
                alt='logo'
                className="logo d-inline-block"
                src="/images/kcell_white.svg"
                height="20"
              />
            </Link>
            {this.renderServiceMenu(this.props)}
          </div>
          <div className='d-flex align-items-center'>
            {this.renderLangSelectBox(this.props)}
            {this.renderChangeCustomerSelectBox(this.props)}
            {this.renderUserMenu(this.props)}
          </div>
        </div>
      </header>
    );
  }
}

export default connect(
  state => ({
    lang: state.lang,
    userInfo: state.userInfo,
    customer: state.customer,
  }),
  dispatch => ({
    changeCustomer: bindActionCreators(changeCustomerAction, dispatch),
    changeLang: bindActionCreators(changeLangAction, dispatch),
  }),
)(Header);
